import RpcClass from "../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

import DataEntity from "../../../../../server/com/silkplm/engine/db/model/DataEntity.js";
let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.healthcheck.Cal';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class Cal extends DataEntity {

    /**
     *  @class Cal
     *  @alias module:src/server/com/silkplm/model/healthcheck/Cal.Cal
     *  
     * */
    constructor(){
        super();

        /** @type {string}  */
        this.id = null;
        /** @type {Date}  */
        this.instantDate = null;
        /** @type {Date}  */
        this.javaUtilDate = null;
        /** @type {LocalDate}  */
        this.localDate = null;
        /** @type {LocalDateTime}  */
        this.localDateTime = null;
        /** @type {LocalTime}  */
        this.localTime = null;

    }





    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/healthcheck/Cal.Cal}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/healthcheck/Cal.Cal}
     */
    withInstantDate(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.instantDate = v;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/healthcheck/Cal.Cal}
     */
    withJavaUtilDate(val){
        let rawValue = val;
        let v = val;
                if(rawValue instanceof Date || rawValue === null || rawValue === undefined){ 
            v = rawValue; 
        } else if(typeof rawValue === 'string' || rawValue instanceof String){ 
            if(rawValue.match(/^\d+$/)){ 
                v = new Date(Number(rawValue)); 
            } else { 
                v = new Date(rawValue); 
            } 
        } else if (typeof rawValue === "number") { 
            v = new Date(rawValue); 
        } else if(rawValue instanceof moment) { 
            v = rawValue.toDate(); 
        } else { 
            v = rawValue; 
        }         

        this.javaUtilDate = v;
        return this;
    };


    /** @returns {Date} */
    javaUtilDateAsDate() {
        return this.javaUtilDate;
    }
    /** @returns {moment} */
    javaUtilDateAsMoment() {
        return moment(this.javaUtilDate);
    }
    /** @returns {string} */
    javaUtilDateAsLocalDate() {
        let m = moment(this.javaUtilDate);
        return m.locale(RpcClass.locale).format("L");
    }
    /** @returns {string} */
    javaUtilDateAsLocalTime() {
        let m = moment(this.javaUtilDate);
        return m.locale(RpcClass.locale).format("LT");
    }
    /** @returns {string} */
    javaUtilDateAsLocalTimeWithSeconds() {
        let m = moment(this.javaUtilDate);
        return m.locale(RpcClass.locale).format("LTS");
    }
    /** @returns {string} */
    javaUtilDateAsLocalDateTime() {
        let m = moment(this.javaUtilDate);
        return m.locale(RpcClass.locale).format("L") + " " + m.locale(RpcClass.locale).format("LT");
    }
    /** @returns {string} */
    javaUtilDateAsLocalDateTimeWithSeconds() {
        let m = moment(this.javaUtilDate);
        return m.locale(RpcClass.locale).format("L") + " " + m.locale(RpcClass.locale).format("LTS");
    }

    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/healthcheck/Cal.Cal}
     */
    withLocalDate(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.localDate = v;
        return this;
    };


    /**
     * @param val {LocalDateTime}
     * @returns {module:src/server/com/silkplm/model/healthcheck/Cal.Cal}
     */
    withLocalDateTime(val){
        let rawValue = val;
        let v = val;
        v = new LocalDateTime(); v.value = rawValue;
        this.localDateTime = v;
        return this;
    };


    /**
     * @param val {LocalTime}
     * @returns {module:src/server/com/silkplm/model/healthcheck/Cal.Cal}
     */
    withLocalTime(val){
        let rawValue = val;
        let v = val;
        v = new LocalTime(); v.value = rawValue;
        this.localTime = v;
        return this;
    };





    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['instantDate'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['javaUtilDate'] = {'remoteType' : 'java.util.Date', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['localDate'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['localDateTime'] = {'remoteType' : 'java.time.LocalDateTime', 'jsType' : 'LocalDateTime', 'mapped' : 'true'};
metadata['localTime'] = {'remoteType' : 'java.time.LocalTime', 'jsType' : 'LocalTime', 'mapped' : 'true'};

metadata.__type__ = 'com.silkplm.model.healthcheck.Cal';
metadata.__type_short__ = 'Cal';
Cal.prototype.__metadata__ = metadata;

Cal.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/healthcheck/Cal */
export default Cal

export { Cal }
